import router from '@/router'

// 页面： 用户提交信息页面
export const toSubmitUserInfo = () => {
    return router.push({ path: '/submitUserInfo' })
}


// 页面： VC模式
export const toVcModel= () => {
    return router.push({ path: '/vcModel' })
}

// 页面： 关于我们
export const toAboutUs= () => {
    return router.push({ path: '/aboutUs' })
}


// 页面： 立即入驻
export const toSettledPlatform= () => {
    return router.push({ path: '/settledPlatform' })
}



